<!-- Toolbar -->
<div class="mb-2">
  <medsurf-design-content-toolbar>
    <div class="p-toolbar-group-start">
      <button medsurf-design-input-button [id]="'vocaculary_group_add'"
        [label]="'global.vocabulary_group_add' | translate"
        [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.ADD"
      (click)="addVocabularyGroup()"></button>
    </div>
  </medsurf-design-content-toolbar>
</div>
<!-- Content -->
@if (vocabularySharedFacade.currentSelectedVocabularyWord$ | async; as vocabularyWords) {
  <!-- Vocabulary Word -->
  <p-accordion [activeIndex]=""
    collapseIcon="false"
    expandIcon="false">
    @for (vocabularyGroupFormData of vocabularyGroupFormsData; track trackByVocabularyGroup($index, vocabularyGroupFormData)) {
      @if ({
        vocabularyWords: vocabularyWords[vocabularyGroupFormData.id]
      }; as vocabularyGroupData) {
        <p-accordionTab>
          <ng-template pTemplate="header">
            <span class="flex align-items-center gap-2 w-full">
              <span class="flex flex-1 font-bold white-space-nowrap uppercase">
                {{ vocabularyGroupFormData.form.controls.name.value }}
              </span>
              <!-- Delete -->
              @if (vocabularyGroupData.vocabularyWords && vocabularyGroupData.vocabularyWords.length === 0) {
                <button medsurf-design-input-button
                        [id]="'vocabulary_group_remove'"
                        [title]="'global.vocabulary_group_remove' | translate"
                        class="absolute right-0 mr-2"
                        [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.DANGER"
                        [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.REMOVE"
                        (click)="removeVocabularyGroup(vocabularyGroupFormData.id)"></button>
              }
            </span>
          </ng-template>
          <ng-template pTemplate="content">
            <!-- Form -->
            @if (vocabularyGroupFormData.form) {
              <medsurf-design-form-control-form
                [formGroup]="vocabularyGroupFormData.form"
                (onSubmit)="onSubmit(vocabularyGroupFormData.id, vocabularyGroupFormData.form)">
                <div class="mt-2">
                  <!-- Vocabulary Group Name -->
                  <medsurf-design-form-control-input-text [control]="vocabularyGroupFormData.form.controls.name"
                    [label]="'global.group_name'"
                  (valueChange)="onSubmit(vocabularyGroupFormData.id, vocabularyGroupFormData.form)"></medsurf-design-form-control-input-text>
                </div>
                <!-- Toolbar -->
                <medsurf-design-content-toolbar>
                  <div class="p-toolbar-group-start">
                    <button medsurf-design-input-button [id]="'vocabulary_word_add'"
                      [label]="'global.vocabulary_word_add' | translate"
                      [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.ADD"
                    (click)="addVocabularyWord(vocabularyGroupFormData.id)"></button>
                  </div>
                </medsurf-design-content-toolbar>
                <!-- Vocabulary Words -->
                <p-table [value]="vocabularyGroupData.vocabularyWords"
                  [rowTrackBy]="rowTrackBy"
                  selectionMode="single"
                  (onRowSelect)="onRowSelect($event, vocabularyGroupFormData.id)"
                  sortField="key">
                  <ng-template pTemplate="header">
                    <tr>
                      <th pSortableColumn="key">
                        <span translate="global.key"></span> <p-sortIcon field="key"></p-sortIcon>
                      </th>
                      <th pSortableColumn="value">
                        <span translate="global.value"></span> <p-sortIcon field="value"></p-sortIcon>
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-vocabularyWord>
                    <tr [pSelectableRow]="vocabularyWord.id">
                      <td>
                        {{vocabularyWord.key}}
                      </td>
                      <td>
                        {{vocabularyWord.value}}
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </medsurf-design-form-control-form>
            }
          </ng-template>
        </p-accordionTab>
      }
    }
  </p-accordion>
}
<!-- -->

<!--
<h2 class="mt-4 mb-4">{{ 'vocabulary' | translate}}</h2>
<div *ngFor="let vocabularyGroup of vocabulary?.vocabularyGroups" class="mt-4">
  <div class="card">
    <div class="card-header bg-primary text-white">
      <h3 *ngIf="vocabularyGroup.expanded">{{ vocabularyGroup.name }}
        <a (click)="vocabularyGroup.expanded = !vocabularyGroup.expanded">
          <span class="fa fa-minus-square float-right text-secondary"></span>
        </a>
      </h3>
      <h3 *ngIf="!vocabularyGroup.expanded">{{ vocabularyGroup.name }}
        <a (click)="vocabularyGroup.expanded = !vocabularyGroup.expanded">
          <span class="fa fa-plus-square float-right text-secondary"></span>
        </a>
      </h3>
    </div>
    <div class="card-body" [ngbCollapse]="!vocabularyGroup.expanded">
      <h5 class="card-title" translate="group_name"></h5>
      <input type="text" [(ngModel)]="vocabularyGroup.name" (ngModelChange)="onChange()">
    </div>
    <div class="card-body" [ngbCollapse]="!vocabularyGroup.expanded">
      <table class="table table-hover">
        <thead class="bg-primary text-white">
          <tr>
            <th><span translate="Schlüssel"></span></th>
            <th><span translate="Wert"></span></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let vocabularyWord of vocabularyGroup?.vocabularyWords">
            <td><input type="text" [(ngModel)]="vocabularyWord.key"></td>
            <td><input type="text" [(ngModel)]="vocabularyWord.value"></td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th><span>Total: {{ vocabularyGroup?.vocabularyWords?.length}}</span></th>
            <th>
              <button class="btn btn-secondary" (click)="addVocabularyWord(vocabularyGroup)" translate="add_vocabularyword"></button>
            </th>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>
<button class="btn btn-secondary mt-4" translate="add_vocabularygroup" (click)="addVocabularyGroup()"></button>
-->
